module.exports = __webpack_public_path__ + "static/media/img_top_main1@2x.088d808e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_top_main1@2x.jpg
// module id = 769
// module chunks = 0